import React from 'react';
import { PERMISSIONS } from 'constants/permissions';
import { EditIconButton } from 'components/common/icons';
import { HasAccess } from 'components/common/accessControl';
import { Button, Col, Divider, Row, Typography } from 'components';
import { useDetails } from './useDetails';
import styles from './styles.module.scss';

export const Details = React.memo(() => {
  const { roleDetails, onUpdateClick } = useDetails();
  return (
    <>
      <Row gutter={[0, 8]}>
        <Col span={24} className={styles.main_info}>
          <Row justify={'space-between'} align={'top'}>
            <Col>
              <Typography.Text className={'font-size-12'} type={'secondary'}>
                ID: {roleDetails.uuid}
              </Typography.Text>
            </Col>
            <HasAccess role={PERMISSIONS.roles.role.write}>
              <Button type={'link'} icon={<EditIconButton />} onClick={onUpdateClick} />
            </HasAccess>
          </Row>
          <Row gutter={[0, 6]}>
            <Col span={24}>
              <Typography.Text title={roleDetails.name} className={styles.name}>
                {roleDetails.name}
              </Typography.Text>
            </Col>
            <Col span={24}>
              <Typography.Text type={'secondary'}>{roleDetails.description}</Typography.Text>
            </Col>
          </Row>
        </Col>
        <Divider className={styles.divider} />
        <Col span={24} className={styles.additional_info}>
          <Row gutter={[0, 14]}>
            <Col span={24}>
              <Row style={{ gap: '9px' }}>
                <Typography.Text className={'font-size-12'} style={{ color: '#99A0AE' }}>
                  {roleDetails.formattedCreatedDate}
                </Typography.Text>
                <Typography.Text className={'font-size-12'} style={{ color: '#99A0AE' }}>
                  {roleDetails.formattedLastModifiedDate}
                </Typography.Text>
              </Row>
            </Col>
          </Row>
        </Col>
      </Row>
    </>
  );
});
